// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko19bv{border-radius:10px}._154i1b66{top:var(--ds-space-050,4px)}\n._154iidpf{top:0}\n._1bsb1osq{width:100%}\n._1bsbwk75{width:var(--_ys364u)}\n._1ltv1b66{left:var(--ds-space-050,4px)}\n._1ltvidpf{left:0}\n._4t3i1osq{height:100%}\n._4t3iwk75{height:var(--_ys364u)}\n._kdam118y{filter:var(--_y27h52)}\n._kqswstnw{position:absolute}\n._t9ec161g{transform:translate3d(0,0,0)}\n._w6ng15vq{backface-visibility:hidden}", ""]);
// Exports
module.exports = exports;
